import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem, Button } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import LogoutIcon from '@mui/icons-material/Logout';
import { AccountCircle } from '@mui/icons-material';

interface HeaderProps {
    user: string;
    cabinet: string;
}

const Header: React.FC<HeaderProps> = ({ user, cabinet }) => {
    const { oktaAuth, authState } = useOktaAuth();

    const handleLogout = async () => {
        await oktaAuth.signOut();
    };

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize: '1.50rem' }}>
                        GED Thetra
                    </Typography>
                    {authState && !authState?.error && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ textAlign: 'right', mr: 2 }}>
                                {user && (
                                    <Typography variant="h6" component="div" sx={{ fontSize: '1rem' }}>
                                        {user.replace('.', '')}
                                    </Typography>
                                )}
                                {cabinet && (
                                    <Typography variant="subtitle2" component="div" sx={{ fontSize: '0.75rem' }}>
                                        {cabinet}
                                    </Typography>
                                )}
                            </Box>
                            <IconButton onClick={handleMenu} sx={{ p: 0 }} color="inherit">
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem key={"deconnexion"} onClick={handleLogout}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleLogout}
                                        startIcon={<LogoutIcon />}
                                    >
                                        Déconnexion
                                    </Button>
                                </MenuItem>
                            </Menu>
                        </Box>
                    )}
                </Toolbar>
            </AppBar>
        </Box>
    );
};

export default Header;
